import { render, staticRenderFns } from "./rolesList.vue?vue&type=template&id=0f88f6e8&scoped=true&"
import script from "./rolesList.vue?vue&type=script&lang=js&"
export * from "./rolesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88f6e8",
  null
  
)

export default component.exports